// import React, { useEffect, useRef, useState } from "react";
// import { Link } from "react-router-dom";
// import { useForm } from "react-hook-form";
// import { yupResolver } from "@hookform/resolvers/yup";
// import * as yup from "yup";
// import $ from "jquery";
// import 'bootstrap-datepicker';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';

// // Define validation schema using yup
// const validationSchema = yup
//   .object({
//     email: yup
//       .string()
//       .email("Please enter a valid email address")
//       .required("Please enter an email address"),
//     password: yup
//       .string()
//       .min(5, "Your password must be at least 5 characters long")
//       .required("Please provide a password"),
//     terms: yup
//       .boolean()
//       .oneOf([true], "Please accept our terms")
//       .required("You must accept the terms of service"),
//   })
//   .required();
// function FormModalUi() {
//     const [date, setDate] = useState('');
//     const datepickerRef = useRef(null);

//     useEffect(() => {
//       // Initialize the Bootstrap Datepicker
//       $(datepickerRef.current).datepicker({
//         format: 'mm/dd/yyyy',
//         todayBtn: 'linked',
//         autoclose: true,
//         startDate: new Date(), // Disable past dates
//       }).on('changeDate', function (e) {
//         // Update the selected date in state
//         setDate(e.format('mm/dd/yyyy'));
//       });

//       return () => {
//         // Cleanup datepicker on unmount
//         $(datepickerRef.current).datepicker('destroy');
//       };
//     }, []);
//   // Use react-hook-form with yup validation
//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//   } = useForm({
//     resolver: yupResolver(validationSchema),
//   });

//   // Form submission handler
//   const onSubmit = (data) => {
//     alert("Form successfully submitted!");
//     console.log(data);
//   };
//   return (
//     <div><div className="modal fade" id="modal-default">
//     <div className="modal-dialog">
//       <div className="modal-content">
//         <div className="modal-header">
//           <h4 className="modal-title">Edit Customer</h4>
//           <button type="button" className="close" data-dismiss="modal" aria-label="Close">
//             <span aria-hidden="true">×</span>
//           </button>
//         </div>
//         <div className="modal-body">
//            {/* Form Start */}
//            <form id="quickForm" onSubmit={handleSubmit(onSubmit)}>
//                     <div className="card-body">
//                       {/* Name Field */}
//                       <div className="form-group">
//                         <label htmlFor="email">Name</label>
//                         <input
//                           type="text"
//                           name="name"
//                           className={`form-control ${
//                             errors.name ? "is-invalid" : ""
//                           }`}
//                           id="name"
//                           placeholder="Enter Name"
//                           {...register("email")}
//                         />
//                         {errors.name && (
//                           <span className="invalid-feedback">
//                             {errors.name.message}
//                           </span>
//                         )}
//                       </div>

//                       <div className="form-group">
//                         <label htmlFor="datepicker">Select Date</label>
//                         <input
//                           type="text"
//                           className="form-control"
//                           id="datepicker"
//                           placeholder="Select Date"
//                           ref={datepickerRef}
//                           value={date}
//                           onChange={() => {}} // Prevent manual input
//                         />
//                       </div>
//                       {/* Email Field */}
//                       <div className="form-group">
//                         <label htmlFor="email">Email address</label>
//                         <input
//                           type="email"
//                           name="email"
//                           className={`form-control ${
//                             errors.email ? "is-invalid" : ""
//                           }`}
//                           id="email"
//                           placeholder="Enter email"
//                           {...register("email")}
//                         />
//                         {errors.email && (
//                           <span className="invalid-feedback">
//                             {errors.email.message}
//                           </span>
//                         )}
//                       </div>

//                       {/* Password Field */}
//                       <div className="form-group">
//                         <label htmlFor="password">Password</label>
//                         <input
//                           type="password"
//                           name="password"
//                           className={`form-control ${
//                             errors.password ? "is-invalid" : ""
//                           }`}
//                           id="password"
//                           placeholder="Password"
//                           {...register("password")}
//                         />
//                         {errors.password && (
//                           <span className="invalid-feedback">
//                             {errors.password.message}
//                           </span>
//                         )}
//                       </div>

//                       {/* Terms Checkbox */}
//                       <div className="form-group mb-0">
//                         <div className="custom-control custom-checkbox">
//                           <input
//                             type="checkbox"
//                             name="terms"
//                             className={`custom-control-input ${
//                               errors.terms ? "is-invalid" : ""
//                             }`}
//                             id="terms"
//                             {...register("terms")}
//                           />
//                           <label
//                             className="custom-control-label"
//                             htmlFor="terms"
//                           >
//                             I agree to the <a href="#">terms of service</a>.
//                           </label>
//                         </div>
//                         {errors.terms && (
//                           <span className="invalid-feedback">
//                             {errors.terms.message}
//                           </span>
//                         )}
//                       </div>
//                     </div>

//                     {/* Card Footer with Submit Button */}
//                     <div className="card-footer">
//                       <button type="submit" className="btn btn-primary" data-dismiss="modal">
//                         Submit
//                       </button>
//                     </div>
//                   </form>
//         </div>
//         {/* <div className="modal-footer justify-content-between">
//           <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
//           <button type="submit" className="btn btn-primary">Save changes</button>
//         </div> */}
//       </div>
//       {/* /.modal-content */}
//     </div>
//     {/* /.modal-dialog */}
//   </div>
//   {/* /.modal */}
//   </div>
//   )
// }

// export default FormModalUi

import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import $ from "jquery";
import "bootstrap-datepicker";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css";


function FormModalUi({ formik, handleCloseModal, children ,title}) {
  return (
    <div>
      <div className="modal fade show  d-block">
        <div className="modal-dialog d-flex align-items-center" style={{height:"calc(100vh - 72px)"}}>
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">{title}</h4>
              <button
                type="button"
                className="close"
                onClick={handleCloseModal}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="quickForm" onSubmit={formik?.handleSubmit}>
                <div className="card-body">{children}</div>
                <div className="card-footer d-flex justify-content-end">
                  <button type="submit" className="btn btn-primary">
                    {/* {formik?.dirty ? (
                        <div class="spinner-border" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      ) : (
                        "Submit"
                      )} */}
                    Submit
                  </button>
                </div>
              </form>
            </div>
            {/* <div className="modal-footer justify-content-between">
          <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
          <button type="submit" className="btn btn-primary">Save changes</button>
        </div> */}
          </div>
          {/* /.modal-content */}
        </div>
        {/* /.modal-dialog */}
      </div>
      {/* /.modal */}
    </div>
  );
}

export default FormModalUi;
